import { render, staticRenderFns } from "./AddressDependencyList.vue?vue&type=template&id=92a1693e&scoped=true"
import script from "./AddressDependencyList.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressDependencyList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a1693e",
  null
  
)

export default component.exports